// extracted by mini-css-extract-plugin
module.exports = {"anchor":"MainMenuItem_anchor__1AU5m","icon":"MainMenuItem_icon__1rZQI","label":"MainMenuItem_label__1z8lj","linkContainer":"MainMenuItem_linkContainer__1Qjeq"};